module.exports = __webpack_public_path__ + "static/SNGLiveWhitePurple-e421fed0be54fbab836e9fbdd79b471e.png";